import { $Q, $Qll } from '../utils/query-selector';
import {
  config,
  configDeferCollections,
  configUpsellCart,
} from './slider-defer';
import { swiperArrowsPagination, swiperPagination } from './slider-swiper';
import { initTopBar } from './top-bar';

const intersectionSlider = (entries, observer) => {
  return entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const { id } = entry.target;
      const preload = $Q('.preload-hidden');

      config(`#${id}`);

      removePreloadHidden(preload);

      if (entry.target.classList.contains('structure-preload'))
        entry.target.classList.remove('structure-preload');

      observer.disconnect();
    }
  });
};

window.addEventListener('load', () => {
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  const preload = $Q('.preload-hidden');

  removePreloadHidden(preload);

  if (mediaQuery.matches) {
    const options = {
      root: null,
      rootMargin: '0px',
    };

    $Qll('.slider_defer').map((slide) => {
      const observer = new IntersectionObserver(intersectionSlider, options);
      observer.observe(slide);
    });

    configDeferCollections(`#slider_collections-js`);
  }

  configUpsellCart();
  swiperArrowsPagination();
  swiperPagination();
  initTopBar();
});

const removePreloadHidden = (element) => {
  if (element) {
    element.classList.remove('preload-hidden');
  }
};

